import Block from '../block'

export default class ShoppingcartAddressSection extends Block {
    static title = 'shoppingcart-address-section'

    init() {
        this.invoiceCheckbox = this.element.querySelector('input[name="invoice_same"]')
        if (this.invoiceCheckbox) {
            this.invoiceCheckbox.addEventListener('change', () => this.onInvoiceCheckboxChange())
        }

        this.formElement = this.element.querySelector('.form')

        this.addressDropdown = this.element.querySelector('[name="address_id"]')
        if (this.addressDropdown && this.formElement) {
            this.addressDropdown.addEventListener('change', () => {
                this.formElement.submit()
            })
        }

        this.invoiceAddressDropdown = this.element.querySelector('.mdc-select--invoice-address')
        if (this.invoiceAddressDropdown && this.addressDropdown) {
            this.invoiceAddressDropdown.addEventListener('change', () => {
                this.formElement.submit()
            })
        }

        this.addressAddForm = this.element.querySelector('.address')
        this.addressAddButton = this.element.querySelector('.shoppingcart-address-section__button--add-address')
        if (this.addressAddButton) {
            this.addressAddButton.addEventListener('click', () => this.toggleAddressForm())
        }
    }

    onInvoiceCheckboxChange() {
        if (this.invoiceCheckbox.checked) {
            this.formElement.submit()
            return
        }

        this.enableInvoiceAddressDropdown()
    }

    toggleAddressForm() {
        if (!this.addressAddForm) {
            return
        }

        this.addressAddForm.classList.toggle('address--hidden')
    }

    enableInvoiceAddressDropdown() {
        if (!this.isValidBlock(this.invoiceAddressDropdown)) {
            return
        }

        this.invoiceAddressDropdown.ref.enableSelect()
    }

    disableInvoiceAddressDropdown() {
        if (!this.isValidBlock(this.invoiceAddressDropdown)) {
            return
        }

        this.invoiceAddressDropdown.ref.disableSelect()
    }
}
